import type { ChevronProps } from 'react-day-picker';

import ChevronDownIcon from '@/assets/svg/bx-chevron-down.svg?react';
import ChevronLeftIcon from '@/assets/svg/bx-chevron-left.svg?react';
import ChevronRightIcon from '@/assets/svg/bx-chevron-right.svg?react';
import { cn } from '@/lib/utils';

export type CalendarChevronProps = ChevronProps;

const CalendarChevron = ({ className, orientation, ...props }: CalendarChevronProps) => {
  if (orientation === 'left') {
    return <ChevronLeftIcon className={cn('size-4 rtl:-scale-x-100', className)} {...props} />;
  }

  if (orientation === 'right') {
    return <ChevronRightIcon className={cn('size-4 rtl:-scale-x-100', className)} {...props} />;
  }

  return <ChevronDownIcon className={cn('size-4', className)} {...props} />;
};

export default CalendarChevron;
